import React from 'react'
import PropTypes from 'prop-types'
import { getSubLabel } from '../../config/accountSubscription'

export const RegDataTable = ({regData}) => {
  const { subscription, name, address, ico, dic, email, date } = regData
  return (
    <table className='cf-tab'>
      <tbody>
        <tr><td>Předplatné:</td><td>{getSubLabel(subscription)}</td></tr>
        <tr><td>Jméno/název:</td><td>{name}</td></tr>
        <tr><td>Adresa/Sídlo:</td><td>{address}</td></tr>
        <tr><td>IČO:</td><td>{ico}</td></tr>
        <tr><td>DIČ:</td><td>{dic}</td></tr>
        <tr><td>E-mail pro zaslání faktur:</td><td>{email}</td></tr>
        <tr><td>Souhlas s obchodními podmínkami:</td><td>ano</td></tr>
        {date ? <tr><td>Datum a čas objednání:</td><td>{date}</td></tr> : null}
      </tbody>
    </table>
  )
}

RegDataTable.propTypes = {
  regData: PropTypes.object
}

export default RegDataTable



// WEBPACK FOOTER //
// ./src/components/UserAccount/RegDataTable.js